import { actionTypes } from '../constants/actionTypes';

export const awardDetailValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.AWARD_DETAIL_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};
